import { render, staticRenderFns } from "./NoteTable.vue?vue&type=template&id=2a8c1501&"
import script from "./NoteTable.vue?vue&type=script&lang=ts&"
export * from "./NoteTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports